import React, { useEffect, useState } from "react";
import Axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CartItem from "../../ViewCart/shared/CartItem";
import Divider from "@mui/material/Divider";
import { getOrderPayload, getPaymentPayload } from "./checkoutUtil";
import { createOrderAPICall, getCartAPIService } from "../../API";
import Constants from "../../../constants";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { decodeUserToken, getPaymentAuthHeader } from "../../../utils";
import { clearCartItems, getCartList } from "../../../actions";
import styled from "styled-components";
import ShipmentsList from "./ShimpentsList";

const CheckoutSummaryNew = (props) => {
  const getPincode = localStorage.getItem("pincode");
  const parsePincode = JSON.parse(getPincode) || "";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // const [paymentFailure, setPaymentFailure] = useState("");
  const { currentStep = {} } = props;
  const { step = 0 } = currentStep;

   const guestUser = useSelector((state) => state.userDetails?.isGuest);

  const AllCartItems = useSelector(
    (state) => state.AllCartItems?.AllCartData || []
  );

  const isGuest = useSelector(
    (state) => state.userDetails?.isGuest || true 
  );

  const userProfile = useSelector((state) => state.userDetails || {});
  const { defaultAddress = {}, isMergeCart = false } = userProfile;
  /*  const shipmentAddress = useSelector(
    (state) => state.userDetails?.defaultAddress || {}
  ); */

  const { address: { pinCode: selectedPincode = "" } = {} } = defaultAddress;
  const { shipments = [], cartPriceDetail: { totalAmount = 0 } = {} } =
    AllCartItems;

  const handleSuccessPayment = async (e) => {
    const URL = Constants?.orders?.create;
    const placeOrderPayload = getOrderPayload({
      defaultAddress,
      AllCartItems,
    });
    placeOrderPayload.payments = [
      {
        ...e,
        chargedAmount: totalAmount || "32506",
        transactionNumber: e?.razorpay_payment_id || "xxx",
        paymentMethod: "prepaid",
      },
    ];

    const paymentHeader = {
      paymentAuthHeader: `${getPaymentAuthHeader()}`,
    };
    createOrderAPICall({
      url: URL,
      data: placeOrderPayload,
      headers: paymentHeader,
    }).then((response) => {
      const { status = 10 } = response;
      if (status === 200) {
        dispatch(clearCartItems());
        navigate("/ordersuccess");
      }
    });
  };

  const handlePlaceOrder = (e) => {
    const URL = Constants?.payment?.createOrder;
    const paymentData = {
      amount: Math.floor(totalAmount) * 100,
      currency: "INR",
      receipt: uuidv4()?.substring(0, 16),
    };
    Axios.post(
      URL,
      {
        ...paymentData,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${getPaymentAuthHeader()}`,
        },
      }
    ).then((response) => {
      const { status = 100, data = "" } = response;
      if (status === 200) {
        const paymentInitiatePayload = getPaymentPayload(data, defaultAddress);
        paymentInitiatePayload.handler = handleSuccessPayment;
        var rzp1 = new window.Razorpay(paymentInitiatePayload);
        rzp1.on("payment.failed", function (response) {
          /* const { reason = "", description = "" } = response?.error;
          setPaymentFailure(`${reason} :${description}`); */
          console.log("PaymentFailure", response);
        });
        rzp1.open();
        e.preventDefault();
      }
    });
  };

  const mergeCartResponse = async () => {
    setIsLoading(true);
    setIsError(false);
    const URL = Constants?.cart?.getCart;
    // const { userId: guestId = "" } = decodeGuestToken();
    const { Token: loggedInUserToken = "" } = decodeUserToken();
    const token = `Bearer ${loggedInUserToken}`;
    const pincode = selectedPincode || parsePincode;
    let headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    /* if (isMergeCart) {
      headers = {
        ...headers,
        guestCartId: guestId,
      };
    } */
    const responseData = await getCartAPIService({
      url: URL,
      pincode: pincode,
      headers,
    });
    const {
      status = 100,
      data: { shipments = [] } = {},
      /* error = "",
      errorMessage = "", */
    } = responseData || {};

    if (status === 200 && shipments?.length) {
      dispatch(getCartList(responseData?.data));
      setIsLoading(false);
      setIsError(false);
    } else {
      setIsLoading(false);
      setIsError(true);
    }
  };

  useEffect(() => {
    if (isMergeCart) {
      //mergecart need to defile when guest login
      mergeCartResponse();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMergeCart]);

  const SummaryContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 99%;
    margin-top: 0.5rem;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.12);
  `;

  console.log("shipments", shipments);


  const PlaceOrderButton = styled.button`

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 40px;
  background-color:rgb(67, 67, 67);
  color: #fff;
  outline: none;
  font-size: 0.9rem;
  margin-left:auto;
  margin-top:1rem;
  margin-right:1rem;
  cursor: pointer;

  @media (max-width: 900px) {
 position: fixed;
 bottom: 0;
 left: 0;
 width: 100%;
 height: 40px;
 z-index: 1000;
}
  `

  const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100px;
  height:35px;
  font-family: "Ancizar Sans", sans-serif;
  background-color: rgb(128, 211, 39);
  color: #fff;
  border-radius: 8px;
  font-size: 0.9rem;  
  margin-top: 1rem;
  margin-left: auto;
  margin-right: 1rem;
  cursor: pointer;
  `
  const handleLogin = () => {
    navigate("/login");
  } 

  return (
    <>
    <SummaryContainer>
      {step !== 3 ? (
        <>
          {isLoading && (
            <>
              <CircularProgress />
            </>
          )}
          {!isLoading && !isError && shipments?.length > 0 && (
            <>

              {shipments?.map((shipment, index) => {
                return <ShipmentsList ship={shipment} />;
              })}
            </>
          )}
        </>
      ) : (
        <></>
      )}
   

    </SummaryContainer>
      {guestUser?<>
      <LoginContainer onClick={handleLogin}>Login</LoginContainer>
      </>:<>
       <PlaceOrderButton
        onClick={handlePlaceOrder}
        disabled={isLoading || isError || shipments?.length === 0}  
        >Place Order</PlaceOrderButton>
      </>}
        </>
  );
};

export default CheckoutSummaryNew;
